module.exports = __webpack_public_path__ + "static/one-nation-7dcc0b1618774426fc0b529f371ba886.jpg";